// removed by extract-text-webpack-plugin
module.exports = {"border-bottom-dotted":"border-bottom-dotted__APGVJ","text-green":"text-green__eM81C","highlights":"highlights__1_pro","label-text":"label-text__3vhiW","highlight":"highlight__8e_p-","label":"label__bsS9S","image":"image__3fNYu","value":"value__nkb-6"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/planHighlights.scss
// module id = 616
// module chunks = 68